import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const ShareButton = ({ slug, title, label = "Deel deze pagina", className = "" }) => {
  const shareUrl = `${BASE}/api/share/${slug}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: title || "De Zeeuwse Tori", url: shareUrl });
        return;
      } catch (e) {
        if (e && e.name === "AbortError") return; // user cancelled
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link gekopieerd! Plak hem in WhatsApp of op social media.");
    } catch (e) {
      window.open(`https://wa.me/?text=${encodeURIComponent(shareUrl)}`, "_blank");
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      data-testid={`share-${slug}`}
      className={
        className ||
        "inline-flex items-center gap-2 border-2 border-[#1B6B2E] text-[#1B6B2E] font-[700] uppercase tracking-wider py-3 px-7 rounded-full hover:bg-[#1B6B2E] hover:text-white transition-colors"
      }
    >
      <Share2 size={18} /> {label}
    </button>
  );
};
